import { Component, Inject, ViewChild, TemplateRef, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ActivatedRoute } from '@angular/router';
import { OverviewViewEnum, OverviewViewEnumType } from '@enums/overview-view.enum';
import { Store } from '@ngrx/store';
import * as setSnackBarActions from '@store/snack-bar/snack-bar.actions';
import { selectStateSnackBar } from '@store/snack-bar/snack-bar-selectors';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('chooseAffiliateModal') chooseAffiliateModal: TemplateRef<any>;
  modalRef: BsModalRef;
  view: OverviewViewEnumType = OverviewViewEnum.OPTION_ORDERS;
  showSnackBar: boolean = false;
  snackBarSuccess: boolean = false;
  snackBarMessage: string = '';

  private unsubscribeAll$: Subject<void> = new Subject();

  constructor(
    @Inject(ActivatedRoute) private _route: ActivatedRoute,
    @Inject(BsModalService) private _modalService: BsModalService,
    @Inject(Store) private store: Store
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectStateSnackBar)
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((snackBarState) => {
        this.showSnackBar = snackBarState.showSnackBar;
        this.snackBarSuccess = snackBarState.snackBarSuccess;
        this.snackBarMessage = snackBarState.snackBarMessage;
      });
  }

  ngAfterViewInit(): void {
    this.showAffiliateOptionsModal(this._route.snapshot.data.incomingData['showAffiliateOptionsModal']);
  }

  handleShowSnackBar(event: boolean): void {
    if (!event) {
      this.store.dispatch(
        setSnackBarActions.setSnackBar({
          snackBarSuccess: false,
          showSnackBar: false,
          snackBarMessage: '',
        })
      );
    }
  }

  showAffiliateOptionsModal(shouldShowModal: boolean): void {
    if (shouldShowModal) {
      this.modalRef = this._modalService.show(this.chooseAffiliateModal, { class: 'modal-dialog-centered modal-sm' });
    }
  }

  toggleView(view: OverviewViewEnumType): void {
    this.view = view;
  }

  get isOptionOrders(): boolean {
    return this.view === OverviewViewEnum.OPTION_ORDERS;
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }
}
